import React from 'react'
import './StudentWork.css'
import { renderStatementWithKaTeX } from '../../../../Status'
const StudentWork = ({Submission}) => {
    function formatDate(date) {
  if (!date) return ""; // handle null/undefined
  const d = new Date(date); // ensure it's a Date object
  const day = d.getDate();
  const month = d.getMonth() + 1; // months are 0-indexed
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

  return (
    <div className='StudentWork-container'>
       
      <div className="StudentWork-header" style={{background: Submission.poster.role.trim().toLowerCase()==="student"? "#EDE6D6": "#D5E6AB"}}>
        <h2 style={{color:Submission.poster.role.trim().toLowerCase()==="student"? "#713520": "#193A3C",fontSize: "1.6em"}}>{Submission.poster.name}</h2>
        <h3>{formatDate(Submission.dateOfSubmission)}</h3>
      </div>
      <hr />
      <div className="StudentWork-content">
        <div className='StudentWork-content-written'>{renderStatementWithKaTeX(Submission.content)}</div>
        
        <div className="Image-Container">
        {Submission.image?<img src={Submission.image} alt="" />:null}

        </div>
      </div>
    </div>
  )
}

export default StudentWork
